/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccordianContent } from '../../models/accordian-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterAccordianContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterAccordianContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterAccordianContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccordianContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterAccordianContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccordianContent>>;
    })
  );
}

apiMasterAccordianContentGetByCriteriaPost.PATH = '/api/Master/AccordianContent/GetByCriteria';
